var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"caption",on:{"click":function($event){return _vm.$emit('restart')}}},[_c('a',{attrs:{"href":"#"}},[_vm._v(_vm._s(_vm.$t('restart')))])])
}
var staticRenderFns = []

export { render, staticRenderFns }